// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import billReadingEntity from './entities/bill-reading.json';
import billReadingMenu from '../pages/bill-reading/menu.json';
import billReadingFullForm from '../pages/bill-reading/forms/full.json';
import billReadingContextForm from '../pages/bill-reading/forms/context.json';
import billReadingMiniForm from '../pages/bill-reading/forms/mini.json';
import billReadingLookupForm from '../pages/bill-reading/forms/lookup.json';
import billReadingTableView from '../pages/bill-reading/views/table.json';
import billReadingCardsView from '../pages/bill-reading/views/cards.json';
import billReadingCalendarView from '../pages/bill-reading/views/calendar.json';
import billReadingDashboardView from '../pages/bill-reading/views/dashboard.json';

/** Тип запису «Читання» зі сторінками пакета: меню, форми та подання з pages/bill-reading/. */
export const billReadingDefinition: IRecordTypeDefinition = {
  ...billReadingEntity,
  views: assembleViewSet({
      table: billReadingTableView,
      cards: billReadingCardsView,
      calendar: billReadingCalendarView,
      dashboard: billReadingDashboardView,
  }),
  form: billReadingFullForm,
  forms: { full: billReadingFullForm, context: billReadingContextForm, mini: billReadingMiniForm, lookup: billReadingLookupForm },
  menu: billReadingMenu,
} as IRecordTypeDefinition;
